import { render, staticRenderFns } from "./onlyShow.vue?vue&type=template&id=524ecfff&scoped=true&"
import script from "./onlyShow.vue?vue&type=script&lang=ts&"
export * from "./onlyShow.vue?vue&type=script&lang=ts&"
import style0 from "./onlyShow.vue?vue&type=style&index=0&id=524ecfff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ecfff",
  null
  
)

export default component.exports